module.exports = __webpack_public_path__ + "static/img/portrait.dc25bcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.jpg
// module id = 301
// module chunks = 0